module.exports = __webpack_public_path__ + "img/w3_circle_filter_white.68df9aec.68df9aec.png";